export default "__VITE_ASSET__EJeC7x5bQxYmCcrtlLPpUw__"